module.exports = __webpack_public_path__ + "img/coming-soon.cdd0b4b7.svg";